import React from "react";
import { Globe, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n";

const shortCode = (code) => (code === "hi" ? "हिं" : (code || "en").slice(0, 2).toUpperCase());

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || "en").split("-")[0];
  return (
    <>
      <label className="hidden lg:flex flex-col leading-none" data-testid="language-select-wrap">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-0.5">Language</span>
        <select value={LANGUAGES.some((l) => l.code === current) ? current : "en"} onChange={(e) => i18n.changeLanguage(e.target.value)}
          aria-label="Language" className="border border-slate-200 hover:border-emerald-500 rounded-lg bg-white text-xs font-semibold text-slate-700 px-2 py-1 outline-none focus:border-emerald-500 cursor-pointer" data-testid="language-select">
          {LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
        </select>
      </label>
      <div className="lg:hidden">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="relative inline-flex items-center gap-0.5 p-2 sm:p-2.5 rounded-full hover:bg-slate-100 transition-colors" aria-label={t("nav.language")} data-testid="language-btn">
              <Globe className="w-5 h-5 text-slate-700" />
              <span className="hidden min-[360px]:inline text-[10px] font-bold text-slate-600" data-testid="language-short-code">{shortCode(current)}</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48 max-h-80 overflow-y-auto" data-testid="language-menu">
            <DropdownMenuLabel className="text-xs">Language / भाषा</DropdownMenuLabel>
            {LANGUAGES.map((l) => (
              <DropdownMenuItem key={l.code} onClick={() => i18n.changeLanguage(l.code)} className="cursor-pointer" data-testid={`language-option-${l.code}`}>
                <span className="flex-1">{l.label}</span>
                {current === l.code && <Check className="w-3.5 h-3.5 text-emerald-700" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  );
}
